import React, { Component } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { TIME_OPTIONS } from "../../constants/index.js"

export class PublishableState extends Component {

  render() {
    var time = null;
    var cz
    var ct

     // console.log(this.props.value);

    if (this.props.value.state === 'UNPUBLISHED') {
      cz = 'not-executed'
      ct = 'Not published'
    } else if (this.props.value.state === 'PUBLISHING') {
      cz = 'executing'
      ct = 'Publishing';
      time = '(since ' + new Date(this.props.value.startedAt).toLocaleDateString('en-UK', TIME_OPTIONS) + ')';
    } else if (this.props.value.state === 'UNPUBLISHING') {
      cz = 'executing'
      ct = 'Unpublishing';
      time = '(since ' + new Date(this.props.value.startedAt).toLocaleDateString('en-UK', TIME_OPTIONS) + ')'
    } else if (this.props.value.state === 'PUBLISHED_PRIVATE') {
      cz = 'executed'
      ct = 'Published private'
      time = '(at ' + new Date(this.props.value.completedAt).toLocaleDateString('en-UK', TIME_OPTIONS) + ')'
    } else if (this.props.value.state === 'PUBLISHED_PUBLIC') {
      cz = 'executed'
      ct = 'Published public'
      time = '(at ' + new Date(this.props.value.completedAt).toLocaleDateString('en-UK', TIME_OPTIONS) + ')'
    } else if (this.props.value.state === 'PUBLISHED') {
      cz = 'executed'
      ct = 'Published'

      if (this.props.executeValue && this.props.executeValue.state == 'EXECUTED' && this.props.value.completedAt < this.props.executeValue.completedAt) {
        cz = 'executed_old'
      }

      time = '(at ' + new Date(this.props.value.completedAt).toLocaleDateString('en-UK', TIME_OPTIONS) + ')'
    } else if (this.props.value.state === 'PUBLISHING_FAILED') {
      cz = 'failed'
      ct = 'Publishing failed'
      time = '(at ' + new Date(this.props.value.completedAt).toLocaleDateString('en-UK', TIME_OPTIONS) + ')';
    } else if (this.props.value.state === 'UNPUBLISHING_FAILED') {
      cz = 'failed'
      ct = 'Unpublishing failed'
      time = '(at ' + new Date(this.props.value.completedAt).toLocaleDateString('en-UK', TIME_OPTIONS) + ')';
    } else if (this.props.value.state === 'WAITING_TO_PUBLISH') {
      cz = 'waiting'
      ct = 'Queued for publication';
      time = '(since ' + new Date(this.props.value.startedAt).toLocaleDateString('en-UK', TIME_OPTIONS) + ')'
    } else if (this.props.value.state === 'PUBLISHING_CANCELED') {
      cz = 'failed'
      ct = 'Publication canceled';
      time = '(at ' + new Date(this.props.value.completedAt).toLocaleDateString('en-UK', TIME_OPTIONS) + ')'
    } else {
      cz = 'not-executed'
      ct = 'Not published'
    }



    return (
      <div>
        <div className={cz}>
          {ct}
        </div>
        {(time || (this.props.value.messages && this.props.value.messages.length > 0)) &&
          <div className="executeinfo">
            {this.props.value.messages && this.props.value.messages.map((msg, index) =>
            <Row key={index}>
              <Col md="12">
                {msg.type === 'ERROR' ? <span className='times crimson-std'>{msg.message}</span> : <span className='times blueviolet-std'>{msg.message}</span>}
              </Col>
            </Row>)}
            {time &&
            <Row>
              <Col md="12">
                <span className='times'>{time}</span>
                {this.props.showTripleStore && this.props.value.tripleStoreName !== null && this.props.value.tripleStoreName !== undefined &&
                <span className='times pl-2'>@{this.props.value.tripleStoreName}</span>}
              </Col>
            </Row>}
          </div>}
        </div>
    )
  }
}

export default PublishableState;
